module.exports = __webpack_public_path__ + "img/IMG_7485.04065fac.webp";